export default (api) => ({
  fetch: (params) => api.$get("/news", { params }),

  fetchOne: (id) => api.$get(`/news/${id}`),

  create: (body) => api.$post("/news", body),

  patch: (id, body) => api.$patch(`/news/${id}`, body),

  remove: (id) => api.$delete(`/news/${id}`),
});
